/* eslint-disable react/jsx-no-useless-fragment */
import { Link } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { IPostDetailResponse } from '@/redux/post/post.d';
import { IProjectEditorState } from '@/redux/post/post.slice';

function LicenseDetailsCard({
  post,
}: {
  post: IPostDetailResponse | IProjectEditorState;
}) {
  const { licenceType } = post;

  if (!licenceType) {
    return <></>;
  }

  const licenseData = [
    {
      name: 'Creative Commons Public Domain',
      description:
        'No rights reserved. You can use, share, remix, and sell without attribution.',
      logo: 'https://licensebuttons.net/p/zero/1.0/88x31.png',
      link: 'https://creativecommons.org/share-your-work/public-domain/cc0/',
    },
    {
      name: 'Creative Commons Attribution',
      description:
        'You can share, remix, and use commercially, but must give credit.',
      logo: 'https://i.creativecommons.org/l/by/4.0/88x31.png',
      link: 'http://creativecommons.org/licenses/by/4.0/',
    },
    {
      name: 'Creative Commons Attribution - Share Alike',
      description:
        'You can share, remix, and use commercially with attribution, but derivatives must use the same license.',
      logo: 'https://i.creativecommons.org/l/by-sa/4.0/88x31.png',
      link: 'http://creativecommons.org/licenses/by-sa/4.0/',
    },
    {
      name: 'Creative Commons Attribution - No Derivatives',
      description:
        "You can share and use commercially with attribution, but can't remix or modify.",
      logo: 'https://i.creativecommons.org/l/by-nd/4.0/88x31.png',
      link: 'http://creativecommons.org/licenses/by-nd/4.0/',
    },
    {
      name: 'Creative Commons Attribution - Noncommercial',
      description:
        'You can share and remix with attribution, but not for commercial use.',
      logo: 'https://i.creativecommons.org/l/by-nc/4.0/88x31.png',
      link: 'http://creativecommons.org/licenses/by-nc/4.0/',
    },
    {
      name: 'Creative Commons Attribution - Noncommercial - Share Alike',
      description:
        'You can share and remix with attribution and same license, but not for commercial use.',
      logo: 'https://i.creativecommons.org/l/by-nc-sa/4.0/88x31.png',
      link: 'http://creativecommons.org/licenses/by-nc-sa/4.0/',
    },
    {
      name: 'Creative Commons Attribution - Noncommercial - No Derivatives',
      description:
        'You can share with attribution for personal use only. No remixing or commercial use.',
      logo: 'https://i.creativecommons.org/l/by-nc-nd/4.0/88x31.png',
      link: 'http://creativecommons.org/licenses/by-nc-nd/4.0/',
    },
  ];

  const licence = licenseData.find((license) => license.name === licenceType);

  if (!licence) {
    return <></>;
  }

  return licenceType ? (
    <Card className="my-5">
      <CardHeader>
        <CardTitle>License Details</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex justify-between">
          <div className="flex flex-col gap-3">
            <p>{licence.name}</p>
            <p>{licence.description}</p>
            <br />
            <a
              href={licence.link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-sm font-medium text-blue-500 hover:text-blue-700 hover:underline"
            >
              <Link className="mr-1 h-4 w-4" />
              View full license details
            </a>
          </div>
          <img src={licence.logo} alt={licence.name} className="w-auto h-10" />
        </div>
      </CardContent>
    </Card>
  ) : (
    <></>
  );
}

export default LicenseDetailsCard;
